
export const dashboardName = 'Personal Shopper Performance'
export const DASHBOARD_PATH = 'sbu/personal-shopper'


export const dashboardDefinition = {
    name: dashboardName,
    entry_points: [
        'sbu/personal-shopper',
    ],
    owners: [
        "raphaelchristopher.a.sepnio@smretail.com"
    ],
    path: DASHBOARD_PATH
}